export default __webpack_public_path__ + "static/media/verificar-resultado-icon-cinza.2bb3fa3f.svg";